import { render, staticRenderFns } from "./BestSendTimesTable.vue?vue&type=template&id=02beba99"
import script from "./BestSendTimesTable.vue?vue&type=script&lang=js"
export * from "./BestSendTimesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports